<div class="container wow fadeIn top-buffer">
    <div class="container my-5">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <b-card title="Add a Team Member" type="secondary" shadow header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5">
                    <b-card-text>
                        <b-form @submit="onSubmit" enctype="multipart/form-data">
                            <b-form-group id="input-group-1" label="Full Name:" label-for="input-1">
                                <b-form-input id="input-1" v-model="form.name" placeholder="Enter full name" required>
                                </b-form-input>
                            </b-form-group>

                            <b-form-group id="input-group-2" label="Phone Number:">
                                <b-form-input maxlength="10" id="input-1" v-model="form.mobile" placeholder="Enter phone number" required>
                                </b-form-input>
                                <div><span class="text-warning">{{valideReceiverNumberMessage}}</span></div>
                            </b-form-group>
                            <b-form-group   label="Initial Password:">
                                <b-form-input type="password" v-model="form.password" placeholder="Enter initial password" required>
                                </b-form-input>
                                <div><span class="text-warning">{{valideReceiverNumberMessage}}</span></div>
                            </b-form-group>
                            <b-form-group  label="Confirm Initial Password:">
                                <b-form-input type="password"  v-model="form.confirm" placeholder="Confirm initial password" required>
                                </b-form-input>
                                <div><span class="text-warning">{{valideReceiverNumberMessage}}</span></div>
                            </b-form-group>
                            <b-button type="submit" variant="primary" class="my-4">Submit Team</b-button>
                        </b-form>
                    </b-card-text>
                </b-card>
            </div>
        </div>
    </div>
    <div class="vld-parent">
        <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>
    </div>
</div>